import { TranslationField } from "~/components/TranslationField";
import { Group } from "~/components/ui/group";
import { Text } from "~/components/ui/text";
import { FaqSidebar } from "../Sidebar";
import { FaqViewerDesktop } from "../Viewer/desktop";

export function FaqRootDesktop(props: { name: string; }) {

	return (
		<>
			<Group class="mt-2">
				<Text class="font-semibold text-left mb-8" size="xl">
					<TranslationField key={props.name} />
				</Text>
			</Group>
			<Group align="stretch">
				<FaqSidebar />
				<div class="p-1" />
				<FaqViewerDesktop />
			</Group>
		</>
	);
}